import { findClientTab, findNavItemByPath, findNavSection } from '../Sidebar/navItems';
import { findSettingsItem } from '../../modules/settings/navItems';

export interface Crumb {
  label: string;
  to?: string;
}

export function buildCrumbs(pathname: string): Crumb[] {
  // /settings/<sub> → Home / Settings / <Sub>
  if (pathname.startsWith('/settings/') && pathname !== '/settings') {
    const sub = findSettingsItem(pathname);
    if (sub) {
      return [
        { label: 'דף הבית', to: '/' },
        { label: 'הגדרות', to: '/settings' },
        { label: sub.label },
      ];
    }
  }

  // /settings index (rarely visited — redirect to /settings/profile)
  if (pathname === '/settings') {
    return [{ label: 'דף הבית', to: '/' }, { label: 'הגדרות' }];
  }

  // Client area → Home / ניהול לקוח / <tab>, with the tab linked on detail pages.
  const clientTab = findClientTab(pathname);
  if (clientTab) {
    const onDetail = pathname !== clientTab.path;
    return [
      { label: 'דף הבית', to: '/' },
      { label: 'ניהול לקוח', to: '/customers' },
      onDetail ? { label: clientTab.label, to: clientTab.path } : { label: clientTab.label },
    ];
  }

  // Top-level via primary sidebar
  const item = findNavItemByPath(pathname);
  if (!item || item.path === '/') {
    return [{ label: 'דף הבית' }];
  }

  // Academy pages → Home / אקדמיה / <page>, with the page linked below it
  // (a lesson under /academy, a skill under /skills).
  if (findNavSection(item)?.id === 'academy') {
    const onDetail = pathname !== item.path;
    return [
      { label: 'דף הבית', to: '/' },
      { label: 'אקדמיה', to: '/academy' },
      onDetail ? { label: item.label, to: item.path } : { label: item.label },
    ];
  }

  return [{ label: 'דף הבית', to: '/' }, { label: item.label }];
}
